import React from 'react';
import { ButtonGroup, MenuItem, Dropdown, NavItem, Nav } from 'react-bootstrap';
import { clearLink, detachedPaymentModal } from './store/deal.store';
import { connect } from 'react-redux';
import { navTo } from '../../../util/util';
import { dealsTypeSwitch } from '@/store/allaround.store';
import AvailableSince, { VERSIONS } from '@/util/version';
import FilterPanel from './search/FilterPanel.jsx';
import { Button } from '../../form/FormControls.jsx';
import { canAccess as supplyDemandCanAccess } from '../reports/store/SupplyDemand.store';
import RoleConfigFilter, { validateRoleConfig } from '../../auth/RoleConfigFilter.jsx';
import newdeal from '@/../style/newdeal.png';

const newButtonMobileStyle = {
  padding: '5px 7px',
  color: '#ffffff',
  backgroundColor: '#43ac6a',
  cursor: 'pointer',
  height: '3em',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginTop: 15,
  fontSize: 'large',
  width: '100%',
};

class DealButtons extends React.Component {
  constructor(props) {
    super(props);
    this.handleAddButton = this.handleAddButtonFunc.bind(this, '');
    this.handleAddBulkButton = this.handleAddButtonFunc.bind(this, '');
    this.handleAddContainerTransport = this.handleAddButtonFunc.bind(this, 'type=container');
    this.handleAddRailcarTransport = this.handleAddButtonFunc.bind(this, 'type=railcar');
    this.handleAddTruckTransport = this.handleAddButtonFunc.bind(this, 'type=truck');
    this.handleTransition = this.handleTransition.bind(this);
  }

  handleAddButtonFunc(params) {
    if (this.props.navigateToDealCreation) {
      this.props.navigateToDealCreation(params);
    }
  }

  handleTransition() {
    if (this.props.handleTransition) {
      this.props.handleTransition();
    }
  }

  render() {
    const transitionButtonId = `transition_deal_${this.props.viewName}`;
    const addButtonId = `new_deal_${this.props.viewName}`;
    // const filterButtonId = `filter_deal_${this.props.viewName}`;

    return (
      <div
        className={`
        ${this.props.noNewButton ? 'no-new-button-deal ' : ''}
        ${this.props.selectedView === this.props.viewName ?
        'selected-deal' : 'unselected-deal'}`}
      >
        <div
          id={transitionButtonId}
          className="transition-deal-button"
          onClick={this.handleTransition}
        >
          {this.props.viewCaption}
        </div>
        {!this.props.noNewButton &&
          this.props.selectedView == this.props.viewName && this.props.viewName == 'transport' ?
          <ButtonGroup>
            <Dropdown id="new_transport_dropdown">
              <Dropdown.Toggle
                title="New" id="new_transport_dropdown_open"
                className={'new-deal-button'}
              >
              New
              </Dropdown.Toggle>
              <Dropdown.Menu className="transportDropdown">
                <MenuItem
                  id={`${addButtonId}_bulk`}
                  onClick={this.handleAddBulkButton}
                >
                  <span >
                    Bulk Vessel
                  </span>
                </MenuItem>

                <MenuItem
                  id={`${addButtonId}_container`}
                  onClick={this.handleAddContainerTransport}
                >
                  <span >
                    Container
                  </span>
                </MenuItem>

                <MenuItem
                  id={`${addButtonId}_railcar`}
                  onClick={this.handleAddRailcarTransport}
                >
                  <span >
                    Railcar
                  </span>
                </MenuItem>
                <MenuItem
                  id={`${addButtonId}_truck`}
                  onClick={this.handleAddTruckTransport}
                >
                  <span >
                    Truck
                  </span>
                </MenuItem>
              </Dropdown.Menu>
            </Dropdown>
          </ButtonGroup>
          : ''
        }
        {this.props.selectedView == this.props.viewName
          && !this.props.noNewButton
          && this.props.viewName != 'transport'
          && this.props.viewName != 'financepayments' ?
          <div
            id={addButtonId}
            onClick={this.handleAddButton}
            className={'new-deal-button'}
          >
            <img src={newdeal} alt={''} />
            New
          </div>
          : ''
        }
      </div>
    );
  }
}
DealButtons.propTypes = {
  navigateToDealCreation: React.PropTypes.func,
  handleTransition: React.PropTypes.func,
  noAddButton: React.PropTypes.bool,
  viewName: React.PropTypes.string.isRequired,
  viewCaption: React.PropTypes.string.isRequired,
  selectedView: React.PropTypes.string,
  noNewButton: React.PropTypes.bool,
};

class NewDealButton extends DealButtons {
  title() {
    return `New ${this.props.viewName}`;
  }
  render() {
    const addButtonId = `new_deal_${this.props.viewName}`;
    return (
      <div>
        {this.props.viewName == 'transport' ?
          <div className="new-transports-block">
            <div
              id={addButtonId}
              onClick={this.handleAddBulkButton}
              style={newButtonMobileStyle}
            >
            New bulk vessel
            </div>
            <div
              id={addButtonId}
              onClick={this.handleAddContainerTransport}
              style={newButtonMobileStyle}
            >
            New container
            </div>
            <div
              id={addButtonId}
              onClick={this.handleAddRailcarTransport}
              style={newButtonMobileStyle}
            >
            New railcar
            </div>
            <div
              id={addButtonId}
              onClick={this.handleAddTruckTransport}
              style={newButtonMobileStyle}
            >
            New truck
            </div>
          </div>
          : ''
        }
        {this.props.viewName != 'transport' && this.props.viewName != 'payments' ?
          <div
            id={addButtonId}
            onClick={this.handleAddButton}
            style={newButtonMobileStyle}
          >
            {this.title()}
          </div>
          : ''
        }
      </div>
    );
  }
}

const PurchaseButtons = connect(
  (state) => ({
    viewName: 'purchase',
    viewCaption: 'Purchase',
    noNewButton: !validateRoleConfig(['myDeals#2', 'allDeals#2']),
    selectedView: state.getIn(['routing', 'locationBeforeTransitions', 'pathname'])
      .split('/').pop(),
  }),
  (dispatch) => ({
    navigateToDealCreation() {
      clearLink(dispatch);
      navTo('/deals/purchase/new', true);
    },
    handleTransition() {
      dealsTypeSwitch(dispatch);
      navTo('/deals/purchase', true);
    },
  })
)(DealButtons);
const SaleButtons = connect(
  (state) => ({
    viewName: 'sale',
    viewCaption: 'Sale',
    noNewButton: !validateRoleConfig(['myDeals#2', 'allDeals#2']),
    selectedView: state.getIn(['routing', 'locationBeforeTransitions', 'pathname'])
      .split('/').pop(),
  }),
  (dispatch) => ({
    navigateToDealCreation() {
      clearLink(dispatch);
      navTo('/deals/sale/new', true);
    },
    handleTransition() {
      dealsTypeSwitch(dispatch);
      navTo('/deals/sale', true);
    },
  })
)(DealButtons);
const Unlinked = connect(
  (state) => ({
    viewName: 'unlinked',
    viewCaption: 'P & S',
    noNewButton: true,
    selectedView: state.getIn(['routing', 'locationBeforeTransitions', 'pathname'])
      .split('/').pop(),
  }),
  (dispatch) => ({
    navigateToDealCreation() {
    },
    handleTransition() {
      dealsTypeSwitch(dispatch);
      navTo('/deals/unlinked', true);
    },
  })
)(DealButtons);
const CommonPaymentButtons = connect(
  (state) => ({
    viewName: 'commonpayments',
    viewCaption: 'Common payments',
    noNewButton: !validateRoleConfig(['financesViewEditDelete']),
    selectedView: state.getIn(['routing', 'locationBeforeTransitions', 'pathname'])
      .split('/').pop(),
  }),
  (dispatch) => ({
    navigateToDealCreation() {
      clearLink(dispatch);
      detachedPaymentModal(dispatch, true);
    },
    handleTransition() {
      dealsTypeSwitch(dispatch);
      navTo('/deals/commonpayments', true);
    },
  })
)(DealButtons);
const OutFinancePaymentButtons = connect(
  (state) => ({
    viewName: 'outpayments',
    viewCaption: 'Outgoing payments',
    noNewButton: true,
    selectedView: state.getIn(['routing', 'locationBeforeTransitions', 'pathname'])
      .split('/').pop(),
  }),
  () => ({
    navigateToDealCreation() {
    },
    handleTransition() {
      navTo('/deals/outpayments', true);
    },
  })
)(DealButtons);
const InFinancePaymentButtons = connect(
  (state) => ({
    viewName: 'inpayments',
    viewCaption: 'Incoming payments',
    noNewButton: true,
    selectedView: state.getIn(['routing', 'locationBeforeTransitions', 'pathname'])
      .split('/').pop(),
  }),
  () => ({
    navigateToDealCreation() {
    },
    handleTransition() {
      navTo('/deals/inpayments', true);
    },
  })
)(DealButtons);
const ClosedPaymentButtons = connect(
  (state) => ({
    viewName: 'closedpayments',
    viewCaption: 'Closed payments',
    noNewButton: true,
    selectedView: state.getIn(['routing', 'locationBeforeTransitions', 'pathname'])
      .split('/').pop(),
  }),
  () => ({
    navigateToDealCreation() {
    },
    handleTransition() {
      navTo('/deals/closedpayments', true);
    },
  })
)(DealButtons);

const CounterpartyOutstandingButtons = connect(
  (state) => ({
    viewName: 'counterpartyoutstanding',
    viewCaption: 'Counterparty outstanding',
    noNewButton: true,
    selectedView: state.getIn(['routing', 'locationBeforeTransitions', 'pathname'])
      .split('/').pop(),
  }),
  () => ({
    navigateToDealCreation() {
    },
    handleTransition() {
      navTo('/deals/counterpartyoutstanding', true);
    },
  })
)(DealButtons);

const TransportButtons = connect(
  (state) => ({
    viewName: 'transport',
    viewCaption: 'Transport',
    noNewButton: !validateRoleConfig(['myTransports#2', 'allTransports#2']),
    selectedView: state.getIn(['routing', 'locationBeforeTransitions', 'pathname'])
      .split('/').pop(),
  }),
  (dispatch) => ({
    navigateToDealCreation(params) {
      clearLink(dispatch);
      navTo(`/deals/transport/new?${params}`, true);
    },
    handleTransition() {
      dealsTypeSwitch(dispatch);
      navTo('/deals/transport', true);
    },
  })
)(DealButtons);


const NewPurchaseButton = connect(
  () => ({
    viewName: 'purchase',
    viewCaption: 'Purchase',
  }),
  (dispatch) => ({
    navigateToDealCreation() {
      clearLink(dispatch);
      navTo('/deals/purchase/new');
    },
  })
)(NewDealButton);

// const NewTransportButton = connect(
//   () => ({
//     viewName: 'transport',
//     viewCaption: 'Transport',
//   }),
//   (dispatch) => ({
//     navigateToDealCreation(params) {
//       clearLink(dispatch);
//       dispatch(push(`/deals/transport/new?${params}`));
//     },
//   })
// )(NewDealButton);
const NewSaleButton = connect(
  () => ({
    viewName: 'sale',
    viewCaption: 'Sale',
  }),
  (dispatch) => ({
    navigateToDealCreation() {
      clearLink(dispatch);
      navTo('/deals/sale/new');
    },
  })
)(NewDealButton);

const SupplyDemandButton = connect(
  (state) => ({
    canAccessReport: state.getIn(['data', 'reports', 'supplyDemand', 'canAccess'], false),
    viewName: 'Supply/Demand',
    viewCaption: 'Supply/Demand',
  }),
  (dispatch) => ({
    navigateToDealCreation() {
      clearLink(dispatch);
      navTo('/reports/supplyDemand');
    },
    canAccess() {
      supplyDemandCanAccess(dispatch);
    },
  })
)(class extends NewDealButton {
  componentWillMount() {
    this.props.canAccess();
  }
  title() {
    return this.props.viewName;
  }
  render() {
    if (this.props.canAccessReport) {
      return super.render();
    }
    return <div />;
  }
});

const isPaymentsTab = (view) => view == 'payments' || view == 'inpayments'
 || view == 'outpayments' || view == 'closedpayments';

const getFilterDealType = (view) => {
  if (isPaymentsTab(view)) { return 'payments'; }
  if (view == 'unlinked') {
    return 'purchase';
  }
  return view;
};

export const COVButtonsContainer = (props) =>
  <div className="second-nav-bar" style={{ padding: 0 }}>
    <Nav pullRight bsStyle="pills">
      <div className={'deal-filters'}>
        <NavItem>
          <Button
            id="back"
            className="deal-actions"
            onClick={props.back}
            style={{ paddingTop: 3 }}
          >
            Back
          </Button>
        </NavItem>
      </div>
    </Nav>
  </div>;
COVButtonsContainer.propTypes = {
  back: React.PropTypes.func,
};


export const DealButtonsContainer = (props) =>
  <div className="second-nav-bar" style={{ padding: 0 }}>
    <Nav pullRight bsStyle="pills">
      <FilterPanel
        dealType={getFilterDealType(props.selectedView)}
        selectedView={props.selectedView}
        showMyDeals={props.selectedView == 'transport'
          ?
          true
          :
          validateRoleConfig(['allDeals#1']) || validateRoleConfig(['viewDealsByRegion'])}
      />
    </Nav>
    <Nav pullLeft className="deal-buttons">
      <RoleConfigFilter
        permissions={['myDeals#1', 'allDeals#1', 'viewDealsByRegion']}
      >
        <NavItem>
          <PurchaseButtons />
        </NavItem>
      </RoleConfigFilter>
      <RoleConfigFilter
        permissions={['myTransports#1', 'allTransports#1']}
      >
        <AvailableSince version={VERSIONS.Clyemne}>
          <NavItem>
            <TransportButtons />
          </NavItem>
        </AvailableSince>
      </RoleConfigFilter>
      <RoleConfigFilter
        permissions={['myDeals#1', 'allDeals#1', 'viewDealsByRegion']}
      >
        <NavItem>
          <SaleButtons />
        </NavItem>
      </RoleConfigFilter>
      <RoleConfigFilter
        permissions={['myDeals#1', 'allDeals#1', 'viewDealsByRegion']}
      >
        <NavItem>
          <Unlinked />
        </NavItem>
      </RoleConfigFilter>
    </Nav>
  </div>;
DealButtonsContainer.propTypes = {
  selectedView: React.PropTypes.string,
};

export const PaymentsButtonsContainer = (props) =>
  <div className="second-nav-bar payments-navbar" style={{ padding: 0 }}>
    <Nav pullLeft className="deal-buttons">
      <NavItem>
        <OutFinancePaymentButtons />
      </NavItem>
      <NavItem>
        <InFinancePaymentButtons />
      </NavItem>
      <NavItem>
        <CommonPaymentButtons />
      </NavItem>
      <NavItem>
        <ClosedPaymentButtons />
      </NavItem>
      {validateRoleConfig(['financesViewEditDelete']) ?
        <NavItem>
          <CounterpartyOutstandingButtons />
        </NavItem>
        :
        ''
      }
    </Nav>
    <Nav pullRight bsStyle="pills">
      <FilterPanel dealType={getFilterDealType(props.selectedView)} />
    </Nav>
  </div>;
PaymentsButtonsContainer.propTypes = {
  selectedView: React.PropTypes.string,
};

export const NewDealButtons = () =>
  <div className="new-deals-buttons">
    <div>
      <NewPurchaseButton />
    </div>
    <div>
      <NewSaleButton />
    </div>
    <div>
      <SupplyDemandButton />
    </div>
  </div>;
